import React from 'react';

import {useStores} from '../../../Hooks';
import {
    trainingAndFieldRoleEnum,
    contentCreatingRoleEnum,
    workspaceUsersEnum,
} from '../../../serverClientShared/sharedEnums';
import {getRoleDisplayText} from './RoleSelector';
import {GroupLabel} from '../../Domain/Groups/helpers/GroupRow';
import ConditionalComponent from '../../Shared/ConditionalComponent';

const hasRoleSelected = (permissions) => {
    if (!permissions) return false;
    return permissions.trainingAndFieldRole !== trainingAndFieldRoleEnum.NONE
        || permissions.contentCreationRole !== contentCreatingRoleEnum.NONE
        || permissions.administrationRole !== workspaceUsersEnum.NONE;
};

const SummaryCard = ({emailCount, permissions}) => {
    const {generalStore} = useStores();
    const roleText = permissions.presetName || getRoleDisplayText(
        permissions.trainingAndFieldRole,
        permissions.contentCreationRole,
        permissions.administrationRole,
        generalStore.translate,
    );

    return (
        <div className="flex flex-col gap-2 p-3 rounded-menu border border-panels-normal bg-windowsandmenus-normal">
            <div className="flex flex-col gap-0.5">
                <span className="text-sm font-semibold text-main-normal">
                    Inviting {emailCount} {emailCount === 1 ? 'member' : 'members'}
                </span>
                <span className="text-xs text-main-disabled">Review before sending</span>
            </div>
            <ConditionalComponent if={hasRoleSelected(permissions) || permissions.presetName}>
                <div className="flex items-center gap-2 pt-1 border-t border-panels-normal">
                    <span className="text-sm text-main-normal font-medium">Role:</span>
                    <span className="text-sm text-main-normal">{roleText}</span>
                </div>
            </ConditionalComponent>
            <ConditionalComponent if={permissions?.groups?.length > 0}>
                <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm text-main-normal font-medium">Groups:</span>
                    {permissions.groups.map((group) => (
                        <GroupLabel key={group.GroupId} group={group} />
                    ))}
                </div>
            </ConditionalComponent>
        </div>
    );
};

export default SummaryCard;
